import { Skeleton } from "@mui/material";
import React from "react";

const SkeletonKit = ({ sx }: { sx?: any }) => {
  return (
    <Skeleton
      sx={{
        width: "200px",
        height: "100px",
        borderRadius: "8px",
        bgcolor: "gray",
        ...sx,
      }}
    />
  );
};

export default SkeletonKit;
